import { ApplicationEvent} from './application-event.model';
import { ApplicationEventType } from '../constants';

export class SearchBannerApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.SearchBanner;

  constructor(private content: string) {}

  getPayload() {
    return {
      category: ApplicationEventType.Interaction,
      action: ApplicationEventType.SearchBanner,
      label: this.content,
      event: ApplicationEventType.SearchBanner
    };
  }
}
